import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EcommerceService {
  http = inject(HttpClient);

  getSourceCurrencyCodes() {
    return this.http.get<string[]>('ecommerce/SourceCurrencyCodes');
  }

  downloadShippingRates() {
    return this.http.get('ecommerce/DownloadShippingRates', {
      responseType: 'blob',
      observe: 'response',
    });
  }

  downloadTaxRates() {
    return this.http.get('ecommerce/DownloadTaxRates', {
      responseType: 'blob',
      observe: 'response',
    });
  }

  downloadCurrencyConversion(sourceCurrencyCode: string) {
    const params = new HttpParams().set('sourceCurrencyCode', sourceCurrencyCode);

    return this.http.get('ecommerce/DownloadExchangeRates', {
      responseType: 'blob',
      observe: 'response',
      params,
    });
  }
}
